module.exports = __webpack_public_path__ + "static/media/Electric.90ffaf26.svg";